<template lang="html">
  <div> 
    <div v-if="hasConfig()">
      <div v-bind:id="id" style="width: 100%; height: 20em;">
      </div>
    </div>
    
    <bulmaGraphProps 
    v-bind:id="id" 
    v-bind:config="config" 
    v-if="showModal && isAdmin() && getEditProps"
    v-on:close="closeModal"
    v-on:update="updateGraph"
    ></bulmaGraphProps>
    
    <button v-if="isAdmin() && getEditProps" class="button" v-on:click="showModal=!showModal">
      <span class="icon is-small">
        <i class="fas fa-pen"></i>
      </span>
      <span>Graph</span>
    </button>
  </div>
  
  
  
</template>

<script>
import * as echarts from 'echarts';
import * as math from 'mathjs';
import bulmaGraphProps from './bulma_graphprops.vue';
export default {
  name: 'bulmaGraph',
  components: {
    bulmaGraphProps
  },
  computed: {
    config: function() {
      return this.$store.getters.getObject(this.id).data;
      // let toReturn = this.$store.getters.getObject(this.id).data;
      // toReturn.salesPerson_field = "SalesPerson__c";
      // return toReturn;
    },
    getEditProps(){
      return this.$store.getters.getEditProps;
    },
    
  },
  props: {
    id: String,
  },
  data() {
    return {
      showModal: false
    }
  },
  mounted: async function() {
    
  },
  beforeMount: async function() {
    await this.bfMo()
  },
  async created() {
  },
  methods: {
    async bfMo(){

      if(this.hasConfig()){
        let query = this.config.query;

        
        //inserimento di filtri dinamici con riferimento al oggetto salesforce in visualizzazione
        query = this.editQuery(query);
     
        
        let records=await this.$store.dispatch('load_query', query )
        console.log("44", records);

        /*rimuovo tutti gli attribute associati da salesforce 
        per problemi di compatibilità con alcuni tipi di graph. es: pie*/
        records.data.map((record)=> {
          if(record.attributes){
            delete record.attributes
          }
          return record
        });
        console.log("55", records);


        records.data = this.aggiungiCampiCalcolati(this.config.rowFormulas, records.data)
        console.log(records.data[0], "test")
      
        console.log("graph qry: ", query)
        var myChart = echarts.init(document.getElementById(this.id));
        
        let c={ ... this.config.options };
        c.dataset.source = records.data;
        
        
        console.log('graph config', c);
        myChart.setOption(c);
      }
    },
    aggiungiCampiCalcolati(fieldsCalcolati, oRecordData){
      let recordData = oRecordData;
      if(fieldsCalcolati && fieldsCalcolati.length > 0){
        // records.data.forEach(element => {
        for(let i = 0; i < recordData.length; i ++){
          console.log(recordData[i], i, "test iter")
          fieldsCalcolati.forEach(field => {
            //calcolo fields e li inserisco
            switch (field.function) {
              case "percent":
                
                //controllo se sono campi o valori statici e ne applico i risultati
                let values = {
                  firstParam: typeof(field.firstParam) == typeof(0) ? field.firstParam: recordData[i][field.firstParam],
                  secondParam: typeof(field.secondParam) == typeof(0) ? field.secondParam: recordData[i][field.secondParam]
                }

                if(values.secondParam == 0) {
                  console.log("trovato calcolo /0")
                  recordData[i][field.name] = 0;
                  break;
                }

                const proportion = 100/values.secondParam;
                // const value = values.firstParam * proportion;
                const value = Math.round((values.firstParam * proportion) * 100) / 100
                console.log(value, "testing calculated value", values);
                recordData[i][field.name] = value;
                
                break;
              default:
                console.log("operatore non previsto rowFormulas: ", field.function)
                // const res = math.evaluate(field.firstParam + field.function + field.secondParam);
                // if(!isNaN(res)){
                //   records.data[0][field.name] = res;
                // }
                // break;
            }
          });
        }
        
      }
      return recordData;
    },
    editQuery(rQuery){
      let query = rQuery;
      let key = this.$store.state.overrideKey ? this.$store.state.overrideKey : this.$store.state.myprofile.contactKey;
      // let Id = this.$store.state.overrideUser ? this.$store.state.overrideUser : this.$store.state.records_id[process];



      if(this.config.context_field && this.config.context_field != ""){
        //ottengo dalla configurazione globale l'istanza del oggetto salesforce
        let process = this.$store.state.global_state_process;
        console.log("process graph: ", process);
        let Id = this.$store.state.records_id[process];
        console.log("Id graph: ", Id);
        //aggiungo la condizione di proprietà alla query
        if(Id){
          const i=query.toUpperCase().search('WHERE');
          const filter= this.config.context_field+"='"+Id+"' AND ";
          query = query.substring(0,i+6)+filter+query.substring(i+6);
          console.log("query ricostruita: ", query)

        }else console.log("id not correctly recovered in graph")

      }

      //aggiungo la condizione di visualizzazione dei progetti gestiti
      if(this.config.salesPerson_field && this.config.salesPerson_field != ""){
        console.log("sono entrato", this.config.salesPerson_field)
        let campo = this.config.salesPerson_field;
        campo = campo.slice(-3)=="__c" ? campo.slice(0, -1) + "r" : campo;
        campo+= ".SP_User_Privileges__c"

        // let key = this.$store.state.myprofile.contactKey;

        console.log("ho costruito il campo: ", campo, " e recuperato user; ", key)
        
        if(key){
          const i=query.toUpperCase().search('WHERE');
          const filter= campo+" INCLUDES ('|"+key+"|') AND ";
          query = query.substring(0,i+6)+filter+query.substring(i+6);
          console.log("query ricostruita: ", query)

        }else console.log("id not correctly recovered in graph salesPerson")
      }
      return query;
    },  
    addQueryFilters(){

    },
    hasConfig(){
      if(this.config) return true;
      return false;
    },
    closeModal(){
      this.showModal = false; 
    },
    updateGraph(){
      console.log("--> updateGraph")
      let m={ message: 'refresh'};
      this.$store.commit('BROADCAST_MESSAGE', m);
      this.showModal=false;
    },
    isAdmin(){
      return this.$store.getters.isAdmin;
    },
  }
}
</script>

<style scoped>
</style>
